/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Conflict,
  DeviceApplianceKindsRequestModel,
  DeviceApplianceKindsResponseModel,
  Forbidden,
  GatewayDeviceInstallationRequestModel,
  GatewayResponseModel,
  NotFound,
  ServiceUnavailable,
  Unauthorized,
} from '../models';

export interface InstallationsGatewayAddGatewayDeviceRequest {
    id: string;
    gatewayDeviceInstallationRequestModel: GatewayDeviceInstallationRequestModel;
}

export interface InstallationsGatewayDeleteGatewayDeviceRequest {
    id: string;
    installationId: string;
}

export interface InstallationsGatewayGetDeviceAppliancesRequest {
    id: string;
}

export interface InstallationsGatewayGetGatewayDevicesRequest {
    id: string;
}

export interface InstallationsGatewayScanGatewayDevicesRequest {
    id: string;
    installationId: string;
}

export interface InstallationsGatewaySetDeviceAppliancesRequest {
    id: string;
    deviceApplianceKindsRequestModel: DeviceApplianceKindsRequestModel;
}

/**
 * 
 */
export class InstallationsGatewayApi extends runtime.BaseAPI {

    /**
     * Creates a new gateway device installation for a customer. Configures gateway connection parameters, network settings, and initializes communication with energy management devices
     * Add Gateway Configuration
     */
    async installationsGatewayAddGatewayDeviceRaw(requestParameters: InstallationsGatewayAddGatewayDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GatewayResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installationsGatewayAddGatewayDevice.');
        }

        if (requestParameters.gatewayDeviceInstallationRequestModel === null || requestParameters.gatewayDeviceInstallationRequestModel === undefined) {
            throw new runtime.RequiredError('gatewayDeviceInstallationRequestModel','Required parameter requestParameters.gatewayDeviceInstallationRequestModel was null or undefined when calling installationsGatewayAddGatewayDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gateway`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.gatewayDeviceInstallationRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new gateway device installation for a customer. Configures gateway connection parameters, network settings, and initializes communication with energy management devices
     * Add Gateway Configuration
     */
    async installationsGatewayAddGatewayDevice(requestParameters: InstallationsGatewayAddGatewayDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GatewayResponseModel> {
        const response = await this.installationsGatewayAddGatewayDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a gateway device installation from the customer account. This action permanently removes the gateway configuration and disconnects all associated energy devices. Cannot be undone
     * Remove Gateway Configuration
     */
    async installationsGatewayDeleteGatewayDeviceRaw(requestParameters: InstallationsGatewayDeleteGatewayDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installationsGatewayDeleteGatewayDevice.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling installationsGatewayDeleteGatewayDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gateway/{installationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a gateway device installation from the customer account. This action permanently removes the gateway configuration and disconnects all associated energy devices. Cannot be undone
     * Remove Gateway Configuration
     */
    async installationsGatewayDeleteGatewayDevice(requestParameters: InstallationsGatewayDeleteGatewayDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.installationsGatewayDeleteGatewayDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all inverter appliance configurations and device types for a customer. Returns classification and kind information for each discovered or configured inverter device
     * Get All Device Inverter Appliances
     */
    async installationsGatewayGetDeviceAppliancesRaw(requestParameters: InstallationsGatewayGetDeviceAppliancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeviceApplianceKindsResponseModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installationsGatewayGetDeviceAppliances.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gateway/device-appliances`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all inverter appliance configurations and device types for a customer. Returns classification and kind information for each discovered or configured inverter device
     * Get All Device Inverter Appliances
     */
    async installationsGatewayGetDeviceAppliances(requestParameters: InstallationsGatewayGetDeviceAppliancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeviceApplianceKindsResponseModel>> {
        const response = await this.installationsGatewayGetDeviceAppliancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all gateway device installations for a customer. Returns complete gateway configurations including connection settings, firmware details, and associated appliances
     * Get All Gateway Configurations
     */
    async installationsGatewayGetGatewayDevicesRaw(requestParameters: InstallationsGatewayGetGatewayDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GatewayResponseModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installationsGatewayGetGatewayDevices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gateway`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all gateway device installations for a customer. Returns complete gateway configurations including connection settings, firmware details, and associated appliances
     * Get All Gateway Configurations
     */
    async installationsGatewayGetGatewayDevices(requestParameters: InstallationsGatewayGetGatewayDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GatewayResponseModel>> {
        const response = await this.installationsGatewayGetGatewayDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiates an appliance discovery scan on the gateway device. Detects and identifies all connected energy devices (inverters, meters, batteries, etc.) on the gateway network. Only one scan can run at a time per gateway
     * Scan Gateway for Connected Appliances
     */
    async installationsGatewayScanGatewayDevicesRaw(requestParameters: InstallationsGatewayScanGatewayDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installationsGatewayScanGatewayDevices.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling installationsGatewayScanGatewayDevices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gateway/{installationId}/scan`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Initiates an appliance discovery scan on the gateway device. Detects and identifies all connected energy devices (inverters, meters, batteries, etc.) on the gateway network. Only one scan can run at a time per gateway
     * Scan Gateway for Connected Appliances
     */
    async installationsGatewayScanGatewayDevices(requestParameters: InstallationsGatewayScanGatewayDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.installationsGatewayScanGatewayDevicesRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the classification and kind/type for inverter devices. Allows reclassification of discovered appliances to ensure accurate device categorization for energy management and reporting
     * Update Inverter Device Kinds
     */
    async installationsGatewaySetDeviceAppliancesRaw(requestParameters: InstallationsGatewaySetDeviceAppliancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeviceApplianceKindsResponseModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installationsGatewaySetDeviceAppliances.');
        }

        if (requestParameters.deviceApplianceKindsRequestModel === null || requestParameters.deviceApplianceKindsRequestModel === undefined) {
            throw new runtime.RequiredError('deviceApplianceKindsRequestModel','Required parameter requestParameters.deviceApplianceKindsRequestModel was null or undefined when calling installationsGatewaySetDeviceAppliances.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gateway/device-appliances`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.deviceApplianceKindsRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates the classification and kind/type for inverter devices. Allows reclassification of discovered appliances to ensure accurate device categorization for energy management and reporting
     * Update Inverter Device Kinds
     */
    async installationsGatewaySetDeviceAppliances(requestParameters: InstallationsGatewaySetDeviceAppliancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeviceApplianceKindsResponseModel>> {
        const response = await this.installationsGatewaySetDeviceAppliancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
